import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-newClose",
  "use": "icon-newClose-usage",
  "viewBox": "0 0 14.849 14.849",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.849 14.849\" id=\"icon-newClose\">\n    <g data-name=\"组 6457\" transform=\"translate(-348.151 -205.5)\">\n        <rect data-name=\"矩形 2245\" width=\"3\" height=\"18\" rx=\"1.5\" transform=\"rotate(-45 424.696 -316.445)\" />\n        <rect data-name=\"矩形 2246\" width=\"3\" height=\"18\" rx=\"1.5\" transform=\"rotate(45 -67.62 538.37)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol